module.exports = __webpack_public_path__ + "img/step-1.15732428.jpg";